import React, { useEffect, useState } from "react";
import { Button, Spinner, Tooltip, OverlayTrigger } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faTrash, faCheckCircle, faTimesCircle, faMagic, faComments } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/api";
const ActionsCell = ({
  claim,
  handleGenerateAi,
  handleViewAi,
  handleApprove,
  handleReject,
  processingAi,
  processingClaims,
  handleViewClick,
  setUserToDelete,
  setDeleteSuccess,
  setDeleteError,
  setShowDeleteModal,
  handleChatClick,
  unread,
  unreadUsers
}) => {
  const { t } = useTranslation();
  console.log("unread", unread);
  console.log("unreadUsers", unreadUsers);
  return (
    <td className="text-end">
      <div className="d-flex justify-content-end gap-2">

        {/* AI Generate / View */}
        {!claim.aiExtractedVariables ? (
          <Button
            size="sm"
            variant="outline-warning"
            disabled={processingAi[claim._id]}
            onClick={() => handleGenerateAi(claim._id)}
          >
            {processingAi[claim._id] ? (
              <Spinner as="span" animation="border" size="sm" />
            ) : (
              <FontAwesomeIcon icon={faMagic} className="me-1" />
            )}
            {processingAi[claim._id] ? t("generating") : t("generateVariables")}
          </Button>
        ) : (
          <Button
            size="sm"
            variant="outline-info"
            onClick={() => handleViewAi(claim.aiExtractedVariables, claim._id)}
          >
            {t("viewVariables")}
          </Button>
        )}

        {/* Approve / Reject */}
        {claim.status === "Waiting for Admin Action" && (
          <>
            <Button
              size="sm"
              variant="success"
              disabled={processingClaims[claim._id]}
              onClick={() => handleApprove(claim._id)}
            >
              {processingClaims[claim._id] ? (
                <Spinner as="span" animation="border" size="sm" />
              ) : (
                <FontAwesomeIcon icon={faCheckCircle} className="me-1" />
              )}
              {processingClaims[claim._id] ? t("processing") : t("approve")}
            </Button>

            <Button
              size="sm"
              variant="outline-danger"
              onClick={() => handleReject(claim._id)}
            >
              <FontAwesomeIcon icon={faTimesCircle} className="me-1" />
              {t("reject")}
            </Button>
          </>
        )}

        {claim.status === "Rejected" && (
          <Button size="sm" variant="outline-danger" disabled>
            {t("rejected")}
          </Button>
        )}
        {/* <div style={{ position: "relative", display: "inline-block" }}>
  <OverlayTrigger placement="top" overlay={<Tooltip>{t("chatAboutInvoice")}</Tooltip>}>
    <Button
      size="sm"
      variant="outline-secondary"
      onClick={() => {
        handleChatClick(claim._id);
        // Reset unread count when opened
        if (unreadCounts[claim._id] > 0) {
          setUnreadCounts((prev) => ({ ...prev, [claim._id]: 0 }));
        }
      }}
      style={{ position: "relative", padding: "6px 10px" }}
    >
      <FontAwesomeIcon icon={faComments} />
      {unreadCounts[claim._id] > 0 && (
        <span
          style={{
            position: "absolute",
            top: "2px",
            right: "2px",
            backgroundColor: "red",
            color: "white",
            borderRadius: "50%",
            minWidth: "16px",
            height: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "10px",
            fontWeight: "bold",
            lineHeight: "1",
            padding: "0 4px",
            boxShadow: "0 0 2px rgba(0,0,0,0.3)",
            transform: "translate(50%, -50%)",
          }}
        >
          {unreadCounts[claim._id]}
        </span>
      )}
    </Button>
  </OverlayTrigger>
</div> */}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t("chatAboutInvoice")}</Tooltip>}>
          <Button
            size="sm"
            variant="outline-secondary"
            onClick={() => handleChatClick(claim._id)}
            className="position-relative"
          >
            <FontAwesomeIcon icon={faComments} />

            {unread > 0 && (
              <span
                className="badge bg-danger text-white position-absolute"
                style={{
                  top: "-6px",
                  right: "-6px",
                  borderRadius: "50%",
                  padding: "3px 6px",
                  fontSize: "10px",
                }}
              >
                {unread}
              </span>
            )}
          </Button>
        </OverlayTrigger>


        {/* View */}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t("viewDetails")}</Tooltip>}>
          <Button
            size="sm"
            variant="outline-primary"
            onClick={() => handleViewClick(claim._id)}
          >
            <FontAwesomeIcon icon={faEye} />
          </Button>
        </OverlayTrigger>

        {/* Delete */}
        <OverlayTrigger placement="top" overlay={<Tooltip>{t("deleteClaim")}</Tooltip>}>
          <Button
            size="sm"
            variant="outline-danger"
            onClick={() => {
              setUserToDelete(claim._id);
              setDeleteSuccess(false);
              setDeleteError(null);
              setShowDeleteModal(true);
            }}
          >
            <FontAwesomeIcon icon={faTrash} />
          </Button>
        </OverlayTrigger>
      </div>
    </td>
  );
};

export default ActionsCell;
